import React from "react";
import '../styles/header.css';

export default function Header() {
  return (
    <header className="header">
      <h1 className="header-title">Mathias H. Løyche</h1>
      <p className="header-subtitle">Datatechnician with a speciality in programming</p>
    </header>
  );
}